import Modernizr from 'modernizr'

(function () {
  let triggerBttn = document.getElementById('trigger-overlay')
  let overlay = document.querySelector('div.oip-overlay')
  let closeBttn = overlay.querySelector('button.overlay-close')
  let transEndEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd',
    'transition': 'transitionend'
  }
  let transEndEventName = transEndEventNames[Modernizr.prefixed('transition')]
  let support = { transitions: Modernizr.csstransitions }

  function toggleOverlay () {
    if (overlay.classList.contains('open')) {
      document.body.classList.toggle('mobile-nav-close')
      document.body.classList.toggle('mobile-nav-open')
      overlay.classList.remove('open')
      overlay.classList.add('close')

      let onEndTransitionFn = function (ev) {
        if (support.transitions) {
          if (ev.propertyName !== 'visibility') return;
          this.removeEventListener(transEndEventName, onEndTransitionFn);
        }
        overlay.classList.remove('close')
      };
      if (support.transitions) {
        overlay.addEventListener(transEndEventName, onEndTransitionFn);
      } else {
        onEndTransitionFn();
      }
    } else if (! overlay.classList.contains('close')) {
      overlay.classList.add('open')

      setTimeout(function () {
        document.body.classList.toggle('mobile-nav-close')
        document.body.classList.toggle('mobile-nav-open')
      }, 800)
    }
  }

  triggerBttn.addEventListener('click', toggleOverlay);
  closeBttn.addEventListener('click', toggleOverlay);
})();



// WEBPACK FOOTER //
// ./resources/assets/js/includes/navigation.js